import { FC, ReactNode } from 'react'
import classNames from 'classnames'
import Dropdown, { DropdownProps } from 'components/Dropdown'

type AOLDropdownProps =
  Pick<DropdownProps, 'align' | 'handleOnSelect' | 'multi' | 'options' | 'testId'>
  & { label?: ReactNode }

const AOLDropdown: FC<AOLDropdownProps> = ({ align, handleOnSelect, label, multi, options, testId }) => {
  const isMulti = multi === true
  const selectedLabel = options.filter(option => option.selected).map(option => option.label).join(', ')

  return (
    <Dropdown
      multi={multi}
      align={align}
      options={options}
      showSelectedIcons={isMulti}
      handleOnSelect={handleOnSelect}
      testId={testId}
      label={({ open }) => (
        <div className='w-100 truncate tl'>
          {
            label ??
              (isMulti
                ? (open
                    ? 'Area of law'
                    : (selectedLabel !== '' ? selectedLabel : 'Area of law'))
                : 'Area of law')
          }
        </div>
      )}
      classes={{
        button: 'bg-white ba br2 b--bright-grey h2 w12-half justify-between',
        chevron: 'black',
        menu: 'bg-white',
        option: ({ focus }) => classNames(
          'black no-underline tl',
          {
            'bg-casper-white': focus,
            'bg-white': !focus
          }
        )
      }}
    />
  )
}

export default AOLDropdown
